import { ICON__ban_solid } from '@/assets/icons_fa';
import { HOOK_GRID2D_CELL__icon_size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__icon_size';
import React, { useMemo } from 'react';

interface PROPS {
  is_hovered: boolean;
  height: number;
  width: number;
}

export const GRID2D_CELL__empty = React.memo(({ is_hovered, height, width }: PROPS) => {
  /*
   * STORE
   */

  const { icon_width, icon_height } = HOOK_GRID2D_CELL__icon_size(width, height);

  /*
   * STATE
   */

  const className = useMemo(() => {
    return `non-draggable flex-center 
            size-full
            rounded-2xl 
            ${is_hovered ? 'border-2 border-white bg-white opacity-50' : 'border border-bar-border bg-transparent'}`;
  }, [is_hovered]);

  const style = useMemo(() => ({ width, height }), [width, height]);

  const style_icon = useMemo(() => ({ width: icon_width, height: icon_height }), [icon_width, icon_height]);

  /*
   * HTML
   */
  return (
    <div {...{ className, style }}>
      <ICON__ban_solid className="!text-bar-border" style={style_icon} />
    </div>
  );
});
